import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import {
  createZeeDocument,
  CreateZeeDocumentApiPayload,
} from '@/actions/zee-document/createZeeDocument';
import { ApiResponse } from '@/types/response.type';
import { ZeeDocument } from '@/types/zee.document.type';

export interface UseCreateZeeDocumentReturn {
  mutate: (
    payload: CreateZeeDocumentApiPayload
  ) => Promise<ApiResponse<ZeeDocument> | undefined>;
  result: ApiResponse<ZeeDocument> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateZeeDocument = (): UseCreateZeeDocumentReturn => {
  const queryClient = useQueryClient();

  const mutation: UseMutationResult<
    ApiResponse<ZeeDocument> | undefined,
    Error,
    CreateZeeDocumentApiPayload
  > = useMutation({
    mutationFn: createZeeDocument,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['zee-documents'] });
    },
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
